import type { ICard, IPhone } from '@/entities/client.entity';

export function resolveCardPhoneLabel(card: ICard, phones: IPhone[] | undefined): string | null {
	if (card.phoneId == null) return null;
	const phone = phones?.find(p => p.id === card.phoneId);
	if (!phone) return null;
	const name = phone.name?.trim();
	const number = phone.number?.trim();
	if (name && number) return `${name} · ${number}`;
	return name || number || null;
}
